/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'


export const RESERVE_QUEUE = (counter) => {
    return (
        <FormattedMessage
            id='building_tooltip.reserve_queue'
            defaultMessage={'Резервов в подготовке: {counter}'}
            values={{
                counter,
            }}
        />
    )
}

export const RESERVE_QUEUE_END = (date) => {
    return (
        <FormattedMessage
            id='building_tooltip.reserve_queue_end'
            defaultMessage={'Все резервы будут готовы {date}'}
            values={{
                date,
            }}
        />
    )
}

export const RESERVE_INFO_LABEL = (
    <FormattedMessage
        id='building_tooltip.reserve_info_label'
        defaultMessage={'Позволяет подготавливать резерв:'}
    />
)

export const UPGRADE_AVAILABLE = (
    <FormattedMessage
        id='building_tooltip.upgrade_available'
        defaultMessage={'Готово к модернизации'}
    />
)



// WEBPACK FOOTER //
// ./components/BuildingTooltip/constants.jsx